import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DUPLICATES_ACTIVATION_ENABLED } from 'reactApp/appHelpers/featuresHelpers/features/duplicates';
import { duplicatesActivate } from 'reactApp/modules/duplicates/duplicates.actions';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { safetyPersonalSessionStorage } from 'reactApp/storage';

const KEY = 'DUPLICATES_ACTIVATION_CALLED';

export const useDuplicatesActivation = () => {
    const dispatch = useDispatch();

    const [isCalled, _] = useState(safetyPersonalSessionStorage.getItem(KEY) === 'true');

    const isOverquota = useSelector(UserQuotaSelectors.isOverquota);
    const isQuotaLoaded = useSelector(UserQuotaSelectors.isQuotaLoaded);
    const isBizUser = useSelector(UserSelectors.isBizUser);
    const isB2BUser = useSelector(UserSelectors.isB2BUser);

    const duplicatesActivationEnabled =
        DUPLICATES_ACTIVATION_ENABLED && !isOverquota && isQuotaLoaded && !isBizUser && !isB2BUser && !isCalled;

    useEffect(() => {
        if (duplicatesActivationEnabled) {
            dispatch(duplicatesActivate());
            safetyPersonalSessionStorage.setItem(KEY, 'true');
        }
    }, [dispatch, duplicatesActivationEnabled]);
};
